export default "__VITE_ASSET__CzQAvzvA__"